import {Pipe, PipeTransform} from '@angular/core';
import {formatCurrency, getCurrencySymbol} from "@angular/common";
import {I18nService} from "@biletix/core/services/i18n.service";

@Pipe({
    name: 'customCurrency',
  standalone: false
})
export class CustomCurrencyPipe implements PipeTransform {


    constructor(private i18n: I18nService) {
    }

    /**
     *
     * @param value
     * @param count
     * @param currencyCode
     * @param display
     * @param digitsInfo
     */
    transform(value: number | string | any,
              quantity: number = -1,
              currencyCode: string | 'TRY' = 'TRY',
              display:
                  | 'code'
                  | 'symbol'
                  | string
                  | boolean = 'symbol',
              digitsInfo: string = '1.2-2',
              locale: string = 'tr'): string | number | any {





        const symbol=getCurrencySymbol(currencyCode, 'wide', locale);
        let formatCurrencyValue = formatCurrency(
            this.formatTurkishLira(value),
            locale,
            symbol,
            currencyCode,
            digitsInfo,
        );

        if (currencyCode === 'TRY' && symbol && formatCurrencyValue.includes(symbol)) {
            const isNegative = formatCurrencyValue.startsWith('-');
            let cleaned = formatCurrencyValue.replace(symbol, '').trim();
            if (isNegative && cleaned.startsWith('-')) {
                cleaned = cleaned.substring(1).trim();
            }
            formatCurrencyValue = (isNegative ? '-' : '') + cleaned + symbol;
        }

        if (quantity > -1) {
          formatCurrencyValue = formatCurrencyValue + "x" + quantity;
        }

        return formatCurrencyValue;

    }


    private formatTurkishLira(value: number | string): number {
        if (value == null || value == '')
            return 0.0;

        return (+value / 100.0);
    }

}
